import PropTypes from 'prop-types';
export const themeProviderPropTypes = {
    theme: PropTypes.object.isRequired,
};
//# sourceMappingURL=ThemeProvider.types.js.map